import { useEffect, useState } from 'react';

import { swalSave } from '../../../utils/swal';
import httpClient from '../../httpClient';

export type EnumOption = {
  value: string;
  label: string;
};

export const useSubtipoDocumentoMedsus = () => {
  const [optionsSubtipoDocumento, setOptionsSubtipoDocumento] = useState<
    EnumOption[]
  >([]);
  const [loadingSubtipoDocumento, setLoadingSubtipoDocumento] = useState(false);

  const load = async () => {
    setLoadingSubtipoDocumento(true);
    try {
      const response = await httpClient.get(
        '/api/medsusdocumento-subtipodocumento',
      );

      const mapped: EnumOption[] =
        response.data?.registros?.map(
          (registro: { id: number; nome: string }) => ({
            value: String(registro.id),
            label: registro.nome,
          }),
        ) ?? [];

      setOptionsSubtipoDocumento([
        { value: '', label: 'Não informado' },
        ...mapped,
      ]);
    } catch (error) {
      console.error('Erro ao buscar Subtipos de Documentos MedSUS.', error);
    } finally {
      setLoadingSubtipoDocumento(false);
    }
  };

  const createSubtipoDocumento = async (
    form: any,
  ): Promise<EnumOption | null> => {
    try {
      const response = await httpClient.post(
        '/api/medsusdocumento-subtipodocumento',
        form,
      );
      swalSave();
      const newOption: EnumOption = {
        value: String(response.data.record.id),
        label: response.data.record.nome,
      };

      setOptionsSubtipoDocumento((prev) => [...prev, newOption]);

      return newOption;
    } catch (error) {
      console.error('Erro ao criar novo Subtipo de Documento MedSUS.', error);
      return null;
    }
  };

  useEffect(() => {
    load();
  }, []);

  return {
    optionsSubtipoDocumento,
    createSubtipoDocumento,
    loadingSubtipoDocumento,
    reload: load,
  };
};
